import { render, staticRenderFns } from "./HorizontalNavMenuGroup.vue?vue&type=template&id=31242e5f&scoped=true"
import script from "./HorizontalNavMenuGroup.vue?vue&type=script&lang=js"
export * from "./HorizontalNavMenuGroup.vue?vue&type=script&lang=js"
import style0 from "./HorizontalNavMenuGroup.vue?vue&type=style&index=0&id=31242e5f&prod&lang=scss"
import style1 from "./HorizontalNavMenuGroup.vue?vue&type=style&index=1&id=31242e5f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31242e5f",
  null
  
)

export default component.exports